import { Tabs } from '@/ui-kit'
import { clsx } from 'clsx'
import { useUiKit } from '../providers'
import { Period } from '../types'

interface PeriodProps {
  value: Period
  onChange: (value: Period) => void
  className?: string
}

export function PeriodTabs({ value, onChange, className }: PeriodProps): React.JSX.Element {
  const { isMobile } = useUiKit()

  return (
    <div className={clsx(!isMobile && 'flex self-start', className)}>
      <Tabs<{ value: Period; title: string }>
        className="h-10"
        tabs={[
          { value: 'day', title: '24 hours' },
          { value: 'month', title: '30 days' },
          { value: 'year', title: '12 months' }
        ]}
        value={value}
        onChange={(period): void => onChange(period.value)}
        size="small"
      />
    </div>
  )
}
